// extracted by mini-css-extract-plugin
export var abbreviation = "ScoreBoard-module--abbreviation--fa2cf";
export var cell = "ScoreBoard-module--cell--ddf4e";
export var clickable = "ScoreBoard-module--clickable--7c3c7";
export var competition = "ScoreBoard-module--competition--67339";
export var counter = "ScoreBoard-module--counter--4aa53";
export var divider = "ScoreBoard-module--divider--0eacc";
export var emptyCell = "ScoreBoard-module--emptyCell--0ef0a";
export var eventName = "ScoreBoard-module--eventName--566bf";
export var halves = "ScoreBoard-module--halves--672e9";
export var header = "ScoreBoard-module--header--a7941";
export var isPrematch = "ScoreBoard-module--isPrematch--51197";
export var isSRM = "ScoreBoard-module--isSRM--a22a8";
export var logo = "ScoreBoard-module--logo--91828";
export var noBetTracker = "ScoreBoard-module--noBetTracker--99ff6";
export var quarters = "ScoreBoard-module--quarters--62072";
export var scoreBoard = "ScoreBoard-module--scoreBoard--68d8f";
export var shinyTeamName = "ScoreBoard-module--shinyTeamName--cdc4b";
export var showVs = "ScoreBoard-module--showVs--f34bf";
export var team = "ScoreBoard-module--team--28f7e";
export var teamName = "ScoreBoard-module--teamName--951d7";
export var thirds = "ScoreBoard-module--thirds--88039";